import { type ComponentProps } from 'react';

import { cn } from '@/util/utils';

/**
 * .skeleton: a loading placeholder on the recessed surface, 4px corners, 14px tall unless sized,
 * pulsing to .55 over 1.4s. Still under reduced motion. Size it to the content it stands in for.
 */
function Skeleton({ className, ref, ...props }: ComponentProps<'div'>) {
    return (
        <div
            data-slot="skeleton"
            aria-hidden
            ref={ref}
            className={cn(
                'bg-muted animate-skeleton-pulse h-3.5 rounded-xs motion-reduce:animate-none',
                className,
            )}
            {...props}
        />
    );
}

export { Skeleton };
